import React, { useState, useEffect } from "react";
import { MeshDataContext } from "./context";

import { getMeshData } from "../services/services";

const MeshProvider = ({ children }) => {
  const [MeshData, setMeshData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMesh = async () => {
      const Mesh = await getMeshData({ lang: "el" })
        .then((response) => {
          if (response.length > 0) {
            setLoading(false);
            return response;
          } else {
            setLoading(false);
            return [];
          }
        })
        .catch((error) => {
          setLoading(false);
          setError(error);
        });
      setMeshData(Mesh);
    };

    fetchMesh();
  }, []);

  return (
    <MeshDataContext.Provider value={{ MeshData, setMeshData, meshLoading: loading, error }}>
      {children}
    </MeshDataContext.Provider>
  );
};

export default MeshProvider;
